<template>
  <div ref="bienvenidaRef" class="bienvenida-section">
    <!-- ENCABEZADO -->
    <div ref="encabezadoRef" class="encabezado-container">
      <p class="encabezado-fecha">02.MAYO.2026<br></p><br>
      <h2 class="encabezado-nombres">
        <span class="nombre-principal">ELIEZER GONZALO </span><br>
        <span class="apellidos-novios">Rojas Alarcón </span><br>

        <div class="separador-central">
          <img src="@/assets/and.png" alt="separador" class="imagen-separador" />
        </div>

        <span class="nombre-principal">HEYMI MELISSA</span><br>
        <span class="apellidos-novios">Hernández Zelaya</span>
      </h2>
    </div>

    <div class="bienvenida-container">
      <p ref="textoPrincipalRef" class="bienvenida-text">{{ mensaje }}</p>
      <p ref="nosCasamosRef" class="textmia">{{ mensajeFinal }}</p>

      <!-- SECCIÓN PADRES / PADRINOS -->
      <div ref="padresContainerRef" class="padres-container">

        <!-- FRASE BENDICIÓN -->
        <p ref="bendicionRef" class="bienvenida-text bendicion-text"></p>

        <!-- PADRES -->
        <h3 class="padres-titulo" ref="padresTituloRef">
          <br /> NUESTROS PADRES
        </h3>

        <p
          v-for="(padre, i) in listaPadres"
          :key="'padre-' + i"
          class="padres-nombre"
          :ref="el => { if (el) padresRefs[i] = el }"
        >
          {{ padre }}
        </p>

        <!-- PADRINOS -->
        <h3 class="padres-titulo" ref="padrinosTituloRef">
          <br /> NUESTROS PADRINOS
        </h3>

        <p
          v-for="(padrino, i) in listaPadrinos"
          :key="'padrino-' + i"
          class="padres-nombre"
          :ref="el => { if (el) padrinosRefs[i] = el }"
        >
          {{ padrino }}
        </p>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'BienvenidaPage',
  setup() {
    const bienvenidaRef = ref(null)
    const encabezadoRef = ref(null)
    const textoPrincipalRef = ref(null)
    const nosCasamosRef = ref(null)
    const padresTituloRef = ref(null)
    const padrinosTituloRef = ref(null)
    const padresContainerRef = ref(null)
    const padresRefs = ref([])
    const padrinosRefs = ref([])
    const bendicionRef = ref(null)

    const mensaje = ref('')
    const mensajeFinal = ref('')

    const listaPadres = [
      'Elicinio Rojas Rangel',
      'Maria Tibisay Alarcon de Rojas ',
      '&',
      'Dennis Alexis Hernández Ponce',
      'Wendy Melissa Hernández Zelaya'
    ]

    const listaPadrinos = [
      'Gilberto Fuentes ',
      'Yorgelis Fuentes Nuñéz',
    
    ]

    const text =
      'Hoy empieza nuestra vida tomados de la mano. Iniciaremos un libro lleno de historias y aventuras como una sola carne, como un solo ser.\n\nGracias por ser parte de esta historia.'

    const textFinal = ''

    onMounted(async () => {
      await nextTick()

      gsap.set(
        [
          encabezadoRef.value,
          textoPrincipalRef.value,
          nosCasamosRef.value,
          bendicionRef.value,
          padresTituloRef.value,
          padrinosTituloRef.value,
          ...padresRefs.value,
          ...padrinosRefs.value
        ],
        { opacity: 0, y: 40 }
      )

      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            const tl = gsap.timeline({
              defaults: { duration: 1, ease: 'power2.out' }
            })

            tl.to(encabezadoRef.value, { y: 0, opacity: 1 }, 0)
              .add(() => (mensaje.value = text))
              .to(textoPrincipalRef.value, { y: 0, opacity: 1 }, '>-0.6')
              .add(() => (mensajeFinal.value = textFinal))
              .to(nosCasamosRef.value, { y: 0, opacity: 1 }, '>-0.5')
              .to(bendicionRef.value, { y: 0, opacity: 1 }, '>-0.45')
              .to(padresTituloRef.value, { y: 0, opacity: 1 }, '>-0.4')
              .to(padresRefs.value, { y: 0, opacity: 1, stagger: 0.25 }, '>-0.2')
              .to(padrinosTituloRef.value, { y: 0, opacity: 1 }, '>-0.2')
              .to(padrinosRefs.value, { y: 0, opacity: 1, stagger: 0.25 }, '>-0.1')

            observer.unobserve(entry.target)
          })
        },
        { threshold: 0.5 }
      )

      if (bienvenidaRef.value) observer.observe(bienvenidaRef.value)
    })

    return {
      bienvenidaRef,
      encabezadoRef,
      textoPrincipalRef,
      nosCasamosRef,
      padresTituloRef,
      padrinosTituloRef,
      padresContainerRef,
      padresRefs,
      padrinosRefs,
      bendicionRef,
      mensaje,
      mensajeFinal,
      listaPadres,
      listaPadrinos
    }
  }
}
</script>

<style scoped>
.small-cross {
  font-size: 0.8em;
  color: #a17e4e; /* Dorado sutil */
  margin-left: 4px;
}
.bienvenida-section {
  padding: 20px 0;
  background-color: rgba(217, 212, 209, 0.95);
     background-size: cover;      /* 🔹 la imagen cubre todo */
  background-position: center; /* centrada */
  background-repeat: no-repeat; /* no se repite */

}

.franja-superior {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding-left: 0;
  overflow: hidden;
}

.ornamento-arriba {
  width: 260px;
  transform: translateX(-80px);
}

.encabezado-container {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
  opacity: 0;
  transform: translateY(50px);
}

.encabezado-fecha {
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  color: #3d3c3c;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.encabezado-nombres {
  font-family: 'Playfair Display', serif;
  font-size: 32px;
  font-weight: bold;
  color: #1e1e1e;
  line-height: 1.2;
}

.nombre-principal {
  font-family: 'nombres';
  font-weight: 400;
}

.nombre-secundario {
  font-style: italic;
  margin-left: 5px;
}

.bienvenida-container {
  text-align: center;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bienvenida-text {
  font-size: 18px;
  font-family: 'padres';
  color: #333;
  margin: 20px;
  transform: translateY(20px);
  opacity: 0;
  white-space: pre-line;
}

/* NUEVO: por si quieres ajustar márgenes de la frase sin tocar el resto */
.bendicion-text {
  margin-top: 10px;
  margin-bottom: 10px;
}

.textmia {
  font-family: "say2";
  font-size: 26px;
  color: #302f2d;
  margin-top: 20px;
  opacity: 0;
}

/* NUEVO: Sección Padres */
.padres-container {
  text-align: center;
      margin-top:-60px;

}
.separador-central {
  text-align: center;
  margin: 10px 0;
}

.imagen-separador {
  width: 150px;
  height: auto;
  margin-top:10px;
  margin-bottom:10px;
  filter: brightness(0.4) contrast(1.2);
  opacity: 0.8;

}

.padres-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 1.5;
  margin-bottom: 20px;
  letter-spacing: 1px;
}
.apellidos-novios {
  font-size: 30px;
  font-family: "cursiva", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  color: #4f4d4d;
}
.padres-nombre {
  font-family: 'padres', serif;
  font-size: 16px;
  color: #444;
  margin-bottom: 8px;
  opacity: 0;
}
</style>
